
















import { FaturamentoDiario } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { title, ticks } from '@/shared/utils/chart';
import { moeda } from "@/shared/filters";

import ChartLine from "@/shared/components/chart-line.vue";

interface FaturamentoAcumulado {
  data: any;
  total: number | null;
  totalMesPassado: number;
}

@Component({
  components: { ChartLine },
})
export default class GraficoFaturamentoAcumulado extends Vue {
  //Atributos
  //Configurações extras para o chartJs (Opcional)
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      callbacks: {
        //Callback para montar o titulo do tooltip
        title: title(),
        //Configurar label do tooltip retornar o texto customizado
        //Com esta configuração deve retornar ex.: "Total: R$ 20,00"
        //Ao invés de: "Total: 20"
        label: (i, data) => {
          return (
            (data.datasets ?? [])[i.datasetIndex ?? 0].label +
            ": " +
            moeda(+(i.value ?? "0"))
          );
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            callback: ticks(),
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            //Começar gráfico a partir do zero, sem valores negativos
            beginAtZero: true,
            //Função que retorna o valor a ser mostrado no eixo y
            //Inplementada para mascarar o valor numério para o formato moeda
            callback: moeda,
          },
        },
      ],
    },
  };
  //A entrada fonte já foi processada?
  processado = true;
  //Fonte de dataSets obtida no processamento da entrada value do componente
  dataAcumulado: FaturamentoAcumulado[] = [];

  //Props
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop() readonly value!: FaturamentoDiario[];

  //Computed
  get labels() {
    return this.dataAcumulado.map((x) => x.data);
  }
  get dataSets(): Chart.ChartDataSets[] {
    return [
      {
        lineTension: 0,
        label: "Valor",
        backgroundColor: "#3e95cd",
        data: this.dataAcumulado.map((x) => x.total),
      },
      {
        lineTension: 0,
        label: "Mês passado",
        backgroundColor: "#cecece",
        data: this.dataAcumulado.map((x) => x.totalMesPassado),
      },
    ];
  }

  mounted() {
    this.onValueChange(this.value);
  }

  @Watch("value")
  onValueChange(val: FaturamentoDiario[]) {
    if (val) {
      this.processado = false;
      this.dataAcumulado = [];
      try {
        for (let i = 0; i < val.length; i++) {
          const item = val[i];
          const dataJson = new Date(parseInt(item.data.substr(6)));

          let anterior = 0;
          let anteriorMesPassado = 0;
          if (i > 0) {
            anterior = this.dataAcumulado[i - 1].total ?? 0;
            anteriorMesPassado = this.dataAcumulado[i - 1].totalMesPassado ?? 0;
          }

          this.dataAcumulado.push({
            data: item.data,
            total: dataJson > new Date() ? null : anterior + item.total,
            totalMesPassado: anteriorMesPassado + item.totalMesPassado,
          });
        }
      } finally {
        this.processado = true;
      }
    }
  }
}
